import React from 'react';
import { ArrowRight, Instagram, Flame, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink text-white pt-24 pb-12 rounded-t-[3rem] mt-[-2rem] relative z-20" data-id="element-36">
      <div className="max-w-7xl mx-auto px-6" data-id="element-37">
        {/* Final CTA */}
        <div className="text-center max-w-3xl mx-auto mb-24" data-id="element-38">
          <h2 className="font-serif text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-39">
            Tu negocio empieza{' '}
            <em className="italic text-accent-light" data-id="element-40">Hoy.</em>
          </h2>
          <a href="https://inkovacreation.store/shop/aaee3cf3-82b8-4d25-9f96-f42edc2ac2a0" target="_blank" rel="noopener noreferrer" className="bg-white text-ink hover:bg-lavender px-9 py-4 rounded-full font-bold text-lg transition-all shadow-lg inline-flex items-center justify-center gap-2 mx-auto group" data-id="element-41">
            Quiero mi guía gratuita
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-42" />
          </a>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-white/10 pt-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-43">
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-44">
            <span className="font-serif italic font-bold text-4xl tracking-tight" data-id="element-45">
              ik.
            </span>
            <span className="text-white/60 text-sm font-medium" data-id="element-46">
              by Inkova LLC
            </span>
          </div>

          <div className="flex items-center gap-6" data-id="element-47">
            <a href="https://www.instagram.com/inkovacreation?igsh=MWFqNWFxc2Jqa205OQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-48">
              <Instagram className="w-5 h-5" data-id="element-49" />
            </a>
            <a href="https://inkovacreation.store" target="_blank" rel="noopener noreferrer" aria-label="Beacons" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-50">
              <Flame className="w-5 h-5" data-id="element-51" />
            </a>
            <a href="mailto:hello@inkova.com" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-52">
              <Mail className="w-5 h-5" data-id="element-53" />
            </a>
          </div>

          <div className="text-center md:text-right" data-id="element-54">
            <p className="text-white/80 font-medium mb-1" data-id="element-55">(786) 303-7695</p>
            <p className="text-white/40 text-sm" data-id="element-56">
              © {new Date().getFullYear()} Inkova LLC. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}